// RTK Query surfaces two error shapes: FetchBaseQueryError for HTTP + parse
// failures, and SerializedError for anything thrown out of transformResponse
// or a mutation body. Reduce both to a single display string.
export const formatQueryError = (error) => {
    if ('status' in error) {
        if (typeof error.status === 'number') {
            return `Request failed: ${error.status}`;
        }
        return `Request failed: ${error.status}${error.error ? ` — ${error.error}` : ''}`;
    }
    return error.message ?? 'Unknown error';
};
